import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height", "viewBox", "fill"];
const _hoisted_2 = ["fill", "fill-opacity"];
export default /*#__PURE__*/ _defineComponent({
    __name: 'ChevronDownIcon',
    props: {
        width: { default: 12 },
        height: { default: 18 },
        viewBox: { default: '0 0 12 18' },
        background: { default: 'none' },
        color: { default: 'white' },
        opacity: { default: 0.32 }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: _ctx.width,
                height: _ctx.height,
                viewBox: _ctx.viewBox,
                fill: _ctx.background
            }, [
                _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M0.275021 0.667014C0.446673 0.501866 0.67687 0.411623 0.915026 0.416117C1.15318 0.42061 1.37981 0.519472 1.54511 0.690977L5.99043 5.40948L10.4357 0.690977C10.5165 0.601897 10.6144 0.529944 10.7235 0.479379C10.8326 0.428813 10.9508 0.400666 11.071 0.396605C11.1912 0.392543 11.311 0.412651 11.4233 0.455735C11.5356 0.498819 11.6381 0.564003 11.7247 0.647426C11.8113 0.730849 11.8803 0.830811 11.9276 0.941391C11.9749 1.05197 11.9995 1.17092 12 1.29118C12.0005 1.41145 11.9768 1.53059 11.9304 1.64154C11.884 1.75249 11.8158 1.853 11.7298 1.9371L6.63745 7.32899C6.55362 7.41597 6.45312 7.48515 6.34195 7.5324C6.23078 7.57965 6.11122 7.604 5.99043 7.604C5.86963 7.604 5.75007 7.57965 5.6389 7.5324C5.52773 7.48515 5.42723 7.41597 5.3434 7.32899L0.251057 1.9371C0.0859092 1.76545 -0.00433365 1.53525 0.00015984 1.2971C0.00465333 1.05894 0.103516 0.832314 0.275021 0.667014Z",
                    fill: _ctx.color,
                    "fill-opacity": _ctx.opacity
                }, null, 8, _hoisted_2)
            ], 8, _hoisted_1));
        };
    }
});
